<template>
    <div :class="{ 'has-mouse': hasMouse }" @touchstart="hasMouse = false">
      <Flipbook
        class="flipbook"
        :pages="pages"
        :pagesHiRes="pagesHiRes"
        :startPage="pageNum"
        v-slot="flipbook"
        ref="flipbook"
        @flip-left-start="onFlipLeftStart"
        @flip-left-end="onFlipLeftEnd"
        @flip-right-start="onFlipRightStart"
        @flip-right-end="onFlipRightEnd"
        @zoom-start="onZoomStart"
        @zoom-end="onZoomEnd"
      >
        <div class="action-bar">
          <left-icon
            class="btn left"
            :class="{ disabled: !flipbook.canFlipLeft }"
            @click="flipbook.flipLeft"
          />
          <plus-icon
            class="btn plus"
            :class="{ disabled: !flipbook.canZoomIn }"
            @click="flipbook.zoomIn"
          />
          <span class="page-num">
            Page {{ flipbook.page }} of {{ flipbook.numPages }}
          </span>
          <minus-icon
            class="btn minus"
            :class="{ disabled: !flipbook.canZoomOut }"
            @click="flipbook.zoomOut"
          />
          <right-icon
            class="btn right"
            :class="{ disabled: !flipbook.canFlipRight }"
            @click="flipbook.flipRight"
          />
        </div>
      </Flipbook>
    </div>
  </template>
  
  <script>
  import "vue-material-design-icons/styles.css";
  import LeftIcon from "vue-material-design-icons/ChevronLeftCircle";
  import RightIcon from "vue-material-design-icons/ChevronRightCircle";
  import PlusIcon from "vue-material-design-icons/PlusCircle";
  import MinusIcon from "vue-material-design-icons/MinusCircle";
  import Flipbook from "flipbook-vue";
  import axios from "axios";
  
  export default {
    name: "ReadNews",
  
    components: {
      Flipbook,
      LeftIcon,
      RightIcon,
      PlusIcon,
      MinusIcon,
    },
  
    data() {
      return {
        pageNum:1,
        //items: [],
        pages: [],
        pagesHiRes: [],
      };
    },
  
    mounted() {
        const code = localStorage.getItem("_");
        if(code){
            axios
        .post("https://ms-sopecam.nexah.net/api/v1/readnewspaper", {
          code: code,
        })
        .then((response) => {
          //this.pages[0] = null;
          if (response.data.errcode === 200) {
            this.pages = atob(response.data.data.pages).split(",");
            //this.items.forEach((item, index) => {
            //  this.pages[index + 1] = item;
            //});
          }
        })
        .catch((error) => {
          console.log(error);
        });
        }
      
    },
  };
  </script>
  